export const preloadingMessages = ['Loading', 'Please wait', 'Almost done'];

const updaters = {};

export function getDotsByCount(count) {
    if (count <= 1) return '.';
    if (count === 2) return '..';
    return '...';
}

export function startProgressUpdater({ key, store, messageInterval, messageUpdateCallback, dotsUpdateCallback }) {
    stopProgressUpdater(key);
    let tick = 0;
    updaters[key] = setInterval(() => {
        tick += 1;
        if (tick % (messageInterval * 2) === 0) {
            messageUpdateCallback(store);
        }
        dotsUpdateCallback(store);
    }, 500);
}

export function stopProgressUpdater(key) {
    if (updaters[key]) {
        clearInterval(updaters[key]);
        delete updaters[key];
    }
}
